<template>
    <div class="productWrap" id="AproductListWrap">
        <div class="headline">产品矩阵</div>
        <!--产品导航-->
        <div class="productNav" @click="productNavEvent">
            <span @click="changeProduct(0)">智能通用服务产品</span>
            <span @click="changeProduct(1)">智能决策产品</span>
            <span @click="changeProduct(2)">定制产品</span>
            <span class="line" :style="navLeftObj"></span>
        </div>
        <!--矩阵-->
        <div class="productListWrap">
            <div class="productList" v-for="(item,index) in productArr" :key="index"
                 @click="toPage(item.notClick,item.page)" :class="item.notClick ? 'notClick' : '' "
                 :style="listWidth">
                <img :src="item.img"/>
                <div class="productListTitle">{{item.title}}</div>
                <p class="productListVal" v-html="item.value"></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "product",
        data() {
            return {
                navLeftObj: {
                    left: "68px"
                },
                listWidth: {
                    width: "286px"
                },
                allArr: {
                    0: [
                        {
                            img: require("@/assets/img/home/个性化工具订阅.png"),
                            title: "个性化工具订阅",
                            value: "开发者便捷小工具，与合作伙伴更好更快更便捷地对接工作",
                            page: "/toolSubscription"
                        },
                        {
                            img: require("@/assets/img/home/因子服务.png"),
                            title: "因子服务",
                            value: "对多维度的信息标签降维分析，辅助企业、券商高效、精准地展开业务分析",
                            page: "/factorServices"
                        },
                        {
                            img: require("@/assets/img/home/风控.png"),
                            title: "风险预警报告",
                            value: "对企业业务的风险因素进行预警输出报告，让企业避免不必要的合作风险因素而增加成本",
                            page: "/riskWarningReport"
                        },
                        {
                            img: require("@/assets/img/home/智能标签.png"),
                            title: "智能标签",
                            value: "通过大数据技术加密聚类得到标签，标签+推荐算法赋能投放、营销、洞察等业务",
                            page: "/smartLabel"
                        },
                        {
                            img: require("@/assets/img/home/模型工厂.png"),
                            title: "模型工厂",
                            value: "利用机器学习技术对数据建立数学模型，帮助企业获取有价值的信息，助力企业高效发展业务",
                            page: "/modelFactory"
                        },
                        {
                            img: require("@/assets/img/home/信息核验.png"),
                            title: "信息核验",
                            value: "暂未上线...",
                            page: "/InformationCheck",
                            notClick: true
                        },
                        {
                            img: require("@/assets/img/home/人脸识别.png"),
                            title: "人脸识别",
                            value: "暂未上线...",
                            page: "/faceRecognition",
                            notClick: true
                        },
                        {
                            img: require("@/assets/img/home/风险名单过滤.png"),
                            title: "风险名单过滤",
                            value: "暂未上线...",
                            page: "/RiskListFiltering",
                            notClick: true
                        },
                    ],
                    1: [
                        {
                            img: require("@/assets/img/home/智能营销系统.png"),
                            title: "智能营销系统",
                            value: "帮助金融企业构建优质的营销生态，从广告、转化、活跃、留存、到流失等用户生命周期数据进行全面分析并优化，达到精细化的运营效果，实现精准营销",
                            page: "/znyxSystem"
                        },
                        {
                            img: require("@/assets/img/home/智能客群洞察系统.png"),
                            title: "智能客群洞察系统",
                            value: "帮助企业深度理解用户群特征，协助企业洞察目标客户的人群特征和线上、线下行为轨迹，有针对性地制定营销、运营策略",
                            page: "/znkqdcSystem"
                        },
                    ],
                    2: [
                        {
                            img: require("@/assets/img/home/个性化定制.png"),
                            title: "个性化定制",
                            value: "暂未上线...",
                            page: "/autobiography",
                            notClick: true
                        },
                        {
                            img: require("@/assets/img/home/企业优化方案定制.png"),
                            title: "企业资源与效率优化",
                            value: "暂未上线...",
                            page: "/optimizeEnterprise",
                            notClick: true
                        },
                        {
                            img: require("@/assets/img/home/大数据操作系统.png"),
                            title: "大数据操作系统设计",
                            value: "暂未上线...",
                            page: "/bigDataOperating",
                            notClick: true
                        },
                    ]
                },
                /*矩阵数据*/
                productArr: []
            }
        },
        created() {
            this.productArr = this.allArr[0];
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            /*导航切换底部线条动画*/
            productNavEvent(e) {
                if (e.target.localName === "span") {
                    let offsetLeft = e.target.offsetLeft;
                    this.navLeftObj.left = offsetLeft + 68 + "px";
                }
            },
            /*导航切换事件*/
            changeProduct(index) {
                console.log(index);
                switch (index) {
                    case 0:
                        this.listWidth.width = "286px";
                        break;
                    case 1:
                        this.listWidth.width = "590px";
                        break;
                    case 2:
                        this.listWidth.width = "387px";
                        break;
                }
                this.productArr = this.allArr[index];
            },
            scrollFun() {
                this.$animate(document.getElementById("AproductListWrap"), "fadeInUp");
            },
            toPage(notClick, page) {
                if (notClick) {
                    return
                }
                this.$router.push({path: page});
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    .productWrap {
        width: 1200px;
        margin: 0 auto;

        .productNav {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 6px;
            margin-bottom: 22px;
            border-bottom: 2px solid rgba(0, 15, 237, .1);

            span {
                display: inline-block;
                width: 286px;
                cursor: pointer;
                font-size: 24px;
                line-height: 33px;
                color: #152346;
                text-align: center;
            }

            .line {
                position: absolute;
                bottom: -2px;
                width: 150px;
                height: 2px;
                transition: all .2s;
                background: #000FED;
                border-radius: 3px;
            }
        }

        .productListWrap {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-bottom: 100px;

            .productList {
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 300px;
                padding: 71px 41px 0;
                margin-bottom: 20px;
                border: 1px solid rgba(18, 8, 87, .3);
                cursor: pointer;

                &:hover {
                    border: 1px solid #fff;
                    box-shadow: 0 2px 48px 10px rgba(062, 60, 77, 0.12);
                }

                img {
                    width: 58px;
                    height: 58px;
                    margin-bottom: 14px;
                }

                .productListTitle {
                    opacity: 0.8;
                    margin-bottom: 10px;
                    font-size: 24px;
                    color: #152346;
                    text-align: center;
                }

                .productListVal {
                    opacity: 0.6;
                    font-size: 12px;
                    color: #152346;
                    text-align: justify;
                    line-height: 24px;
                }
            }

            .notClick {
                opacity: 0.3;
                cursor: not-allowed;
            }
        }
    }
</style>
